import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { useState, useEffect, useContext } from "react";
import {
  getAllZones,
  getAllCategory,
  ExpertTime,
  ExpertNewRequest,
} from "../../../services/kojaServices";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { newRequestSchema } from "../../../validation/validation";
import { toast } from "react-hot-toast";
import { expertContext } from "../../../context/expertcontext";

const NewRequest = () => {
  const [zones, setZones] = useState([]);
  const [category, setCategory] = useState([]);
  const [list, setList] = useState([]);
  const [list2, setList2] = useState([]);
  const { setPage } = useContext(expertContext);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setPage("درخواست جدید");
        const { data: zones } = await getAllZones();
        setZones(zones.result);
        const { data: category } = await getAllCategory();
        setCategory(category.result);
        const { data } = await ExpertTime();
        // setList(data.result);
        setData(data.result);
        // console.log(data.result);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  const setData = (data) => {
    const groups = {};
    data.forEach((item) => {
      const date = item.date;
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(item);
    });

    const groupedData = Object.values(groups);

    // console.log(groupedData);
    setList(groupedData);
  };

  const submitForm = async (values, resetForm) => {
    try {
      if (values.paymentType === undefined){
        toast.error("لطفا ابتدا نوع پیش پرداخت را تعیین کنید.");  
      }else{
        const { data } = await ExpertNewRequest(values);
        toast.success("درخواست شما با موفقیت ثبت شد");
        resetForm();
      }
      
    } catch (err) {
      toast.error("خطایی رخ داده است مجدد تلاش کنید");
    }
  };
  const setDateTime = (e, setFieldValue) => {
    const selectedId = e.target.value; // ID of the selected option
    const selectedGroup = list.find((group) =>
      group.some((item) => item.id == selectedId)
    );
    let time = e.target.options[e.target.selectedIndex].text.split("-")[1];
    //  time = time.split(" ")[1]
    console.log(time);
    setFieldValue(
      "faDateTime",
      `${selectedGroup[0].fa_day} ${selectedGroup[0].fa_date} ساعت${time}`
    );
  };
  return (
    <div
      style={{
        paddingTop: "10px",
        minHeight: "100vh",
        background: "linear-gradient(116.82deg, #658491 0%, #FFFFFF 100%)",
      }}
    >
      <Header />
      <div className="d-flex my-request-box">
        <Menu />
        <div className="p-2 me-4 w-100">
          <Formik
            initialValues={{
              zone: "",
              ZoneSlug: "",
              CategorySlug: "",
              category: "",
              timeId: "",
              address: "",
              name: "",
              phone: "",
              NI: "",
              faDateTime: "",
            }}
            validationSchema={newRequestSchema}
            onSubmit={(values, { resetForm }) => {
              submitForm(values, resetForm);
            }}
            enableReinitialize={true}
          >
            {({
              isSubmitting,
              errors,
              setFieldValue,
              touched,
              handleChange,
            }) => (
              <Form>
                <div className="text-end">
                  <h3>اطلاعات ملک</h3>
                  <div className="row w-100 p-2 new-request-input-box">
                    <div className="mb-3 col-sm-3">
                      <label
                        className="mb-1 me-3 d-flex label-form"
                        htmlFor="zone"
                      >
                        منطقه :{" "}
                      </label>
                      <Field
                        name="zone"
                        as="select"
                        className="w-100 new-request-input"
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue(
                            "ZoneSlug",
                            e.target.options[e.target.selectedIndex].text
                          );
                        }}
                      >
                        <option>لطفا یک گزینه انتخاب کنید</option>
                        {zones.map((s, index) => (
                          <option key={index} value={s.id}>
                            {s.name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="zone"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-3 col-sm-3">
                      <label
                        className="mb-1 ms-2 d-flex label-form"
                        htmlFor="name"
                      >
                        نوع ملک :{" "}
                      </label>
                      <Field
                        name="category"
                        as="select"
                        className="w-100 new-request-input"
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue(
                            "CategorySlug",
                            e.target.options[e.target.selectedIndex].text
                          );
                        }}
                      >
                        <option>لطفا یک گزینه انتخاب کنید</option>
                        {category.map((s, index) => (
                          <option key={index} value={s.id}>
                            {s.name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="category"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-3 col-sm-6">
                      <label
                        className="mb-1 ms-2 d-flex label-form "
                        htmlFor="address"
                      >
                        {" "}
                        آدرس :{" "}
                      </label>
                      <Field
                        name="address"
                        type="text"
                        className="w-100 new-request-input"
                      />
                      <ErrorMessage
                        name="address"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="text-end mt-3">
                  <h3>اطلاعات مالک</h3>
                  <div className="row w-100 p-2 new-request-input-box">
                    <div className="mb-3 col-sm-4">
                      <label
                        className="mb-1 ms-2 d-flex label-form "
                        htmlFor="name"
                      >
                        نام و نام خانوادگی:
                      </label>
                      <Field
                        name="name"
                        type="text"
                        className="w-100 new-request-input"
                      />
                      <ErrorMessage
                        name="name"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-3 col-sm-4">
                      <label
                        className="mb-1 ms-2 d-flex label-form "
                        htmlFor="phone"
                      >
                        شماره تماس :
                      </label>
                      <Field
                        name="phone"
                        type="text"
                        className="w-100 new-request-input"
                      />
                      <ErrorMessage
                        name="phone"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="mb-3 col-sm-4">
                      <label
                        className="mb-1 ms-2 d-flex label-form"
                        htmlFor="name"
                      >
                        کد ملی :
                      </label>
                      <Field
                        name="nationalId"
                        type="number"
                        className="w-100 new-request-input"
                      />
                      <ErrorMessage
                        name="nationalId"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="text-end mt-3">
                  <h3>تنظیم زمان کارشناسی</h3>
                  <div className="row w-100 p-2 new-request-input-box justify-content-between align-items-center">
                    <div className="mb-3 col-sm-5  ">
                      <label
                        className="mb-1 ms-2 d-flex label-form"
                        htmlFor="timeId"
                      >
                        انتخاب زمان کارشناسی:
                      </label>
                      <Field
                        name="timeId"
                        as="select"
                        className="w-100 new-request-input"
                        onChange={(e) => {
                          handleChange(e);
                          setDateTime(e, setFieldValue);
                        }}
                      >
                        <option>لطفا یک گزینه انتخاب کنید</option>
                        {list.map((i, index) => (
                          <optgroup
                            key={index}
                            label={`${i[0].fa_day} ${i[0].fa_date}`}
                          >
                            {i.map((t, index2) => (
                              <option value={t.id} key={index2}>
                                ساعت - {t.time}
                              </option>
                            ))}
                          </optgroup>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="timeId"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    {/* <div className="text-center mb-3 mt-3 col-sm-5">
                      <button
                        className="new-request-btn btn"
                        style={{ width: "300px" }}
                      >
                        درخواست جدید
                      </button>
                    </div> */}
                  </div>
                </div>

                {/* I'm add from here.... */}
                <div className="text-end mt-3">
                  <h3>تنظیم نوع پرداخت</h3>
                  <div className="row w-100 p-2 new-request-input-box justify-content-between align-items-center">
                    <div className="mb-3 col-sm-5  ">
                      <label
                        className="mb-1 ms-2 d-flex label-form"
                        htmlFor="paymentType"
                      >
                        انتخاب نوع پرداخت:
                      </label>
                      <Field
                        name="paymentType"
                        as="select"
                        className="w-100 new-request-input"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                      >
                        <option>لطفا یک گزینه انتخاب کنید</option>
                    
                          <option value="Cash">نقد</option>
                          <option value="Online">آنلاین</option>
                          <option value="POS">کارت خوان</option>
                      </Field>
                      <ErrorMessage
                        name="paymentType"
                        render={(msg) => (
                          <div className="text-danger">{msg}</div>
                        )}
                      />
                    </div>
                    <div className="text-center mb-3 mt-3 col-sm-5">
                      <button
                        className="new-request-btn btn"
                        style={{ width: "300px" }}
                      >
                        درخواست جدید
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default NewRequest;
